import { Component, ElementRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppMenu } from './app.menu';
import { BrandingService } from '@/services/branding.service';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu, RouterModule],
    template: ` <div class="layout-sidebar">
        <!-- لوگوی بارگذاری‌شده در «ظاهر و رنگ‌بندی»، وگرنه لوگوی پیش‌فرض -->
        <a
            class="lena-sidebar-brand"
            [class.custom-logo]="!!branding.logoUrl()"
            [style.background-image]="branding.logoUrl() ? 'url(' + branding.logoUrl() + ')' : null"
            routerLink="/"
            [attr.aria-label]="branding.appName()"
        ></a>

        <div class="lena-sidebar-menu">
            <app-menu></app-menu>
        </div>

        <div class="lena-sidebar-art" aria-hidden="true">
            <img src="assets/images/artemis.png" alt="" />
        </div>

        <div class="lena-sidebar-footer">
            <div class="lena-sidebar-rule"></div>
            <span class="lena-sidebar-tagline">ارزش، اعتماد، همراه شما</span>
        </div>
    </div>`
})
export class AppSidebar {
    constructor(
        public el: ElementRef,
        public branding: BrandingService
    ) {}
}
